import { render, staticRenderFns } from "./MdtFeatureUnavailable.vue?vue&type=template&id=742ea92f&scoped=true"
import script from "./MdtFeatureUnavailable.vue?vue&type=script&lang=js"
export * from "./MdtFeatureUnavailable.vue?vue&type=script&lang=js"
import style0 from "./MdtFeatureUnavailable.vue?vue&type=style&index=0&id=742ea92f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ea92f",
  null
  
)

export default component.exports